import { SET_CARRITO } from "../constanst";

const initialState = {
    carrito: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CARRITO:
            return {
                ...state,
                carrito: action.payload
            }
        default:
            return state;
    }
}